import { ReactNode, useContext } from "react"

import { CurrentUserContext } from "context/CurrentUserContext"

import Loader from "components/Loader"
import NoFeatureAccess from "components/NoFeatureAccess"

interface IFeatureRoute {
    feature: string
    children: ReactNode
}

// Guards a route behind a company feature flag. When the feature is OFF for the
// user's company it renders the "no access" message instead of the content, so
// a manually typed URL does not reach a disabled screen (ASA-225).
const FeatureRoute = ({ feature, children }: IFeatureRoute) => {
    const { isFeatureEnabled, featuresLoaded } = useContext(CurrentUserContext)

    // Wait for the feature map so a disabled screen never renders (and never
    // fires its API calls) before the check can be made.
    if (!featuresLoaded) {
        return <Loader />
    }

    if (!isFeatureEnabled(feature)) {
        return <NoFeatureAccess />
    }

    return <>{children}</>
}

export default FeatureRoute
